import styles from './gulfstreamComponent.module.scss';
import Image from 'next/image';

const GulfstreamComponent = () => {
  return (
    <section className="container">
      <div className={styles.gulfstreamComponentWrapper}>
        <div className={styles.gulfstreamComponentTopWrapper}>
          <div className={styles.TextWrapper}>
            <h2 className={styles.componentTitle}>GIV - The Gulfstream IV</h2>
            <p className={styles.text}>
              The Gulfstream IV is a masterclass in performance and range,
              ideally suited for nonstop transcontinental and transatlantic
              missions. This long-range business jet offers an exceptional blend
              of speed, capacity, and versatility. While the aircraft is capable
              of accommodating up to 19 passengers in some configurations, the
              typical layout is optimized for 14, ensuring generous personal
              space and comfort.
              <br />
              <br />
              Cruising at speeds of up to 460 knots (approximately 530 miles per
              hour or 850 kilometers per hour), the GIV efficiently bridges vast
              distances, offering a maximum range of about 4,220 nautical miles
              (4855 miles). This makes it a preferred choice for travelers
              needing to connect major global cities without layovers.
            </p>
          </div>
          <Image
            src="/img/gulfstreamComponent/gulfstream-img.webp"
            alt="Gulfstream IV"
            width={590}
            height={345}
            className={styles.gulfstreamImage}
          />
        </div>
        <div className={styles.gulfstreamComponentBlock}>
          <div className={styles.text}>
            Inside, the cabin dimensions further enhance the flying experience.
            With a height of just over six feet, passengers can move about
            freely without crouching, and the cabin&#39;s width provides ample
            room for varied seating and amenity configurations. At over 45 feet
            in length, the cabin offers multiple zones for work, rest, and
            relaxation—making long-haul flights not only bearable but enjoyable.
            <br />
            <br />
            Whether crossing oceans or coasts, the Gulfstream IV delivers a
            commanding performance matched by its timeless design and enduring
            appeal.
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>Interior Excellence</h4>
          <div className={styles.text}>
            Step into a cabin where luxury meets functionality. The Gulfstream
            IV&#39;s spacious interior is thoughtfully designed to cater to your
            every need:
            <br />
            <br />
            <span>Seating Arrangements:</span> Configurable layouts featuring
            plush leather seats, including club seating, conference areas, and
            divans that convert into beds for restful sleep
            <br />
            <span>Amenities:</span> <br />
            <ul>
              <li>
                Fully equipped galley with microwave, oven, refrigerator, and
                coffee makers
              </li>
              <li>
                Private lavatory for passengers; some configurations include a
                separate crew lavatory
              </li>
              <li>
                Advanced entertainment systems with DVD players, satellite
                communication, and Airshow displays
              </li>
              <li>
                In-flight accessible baggage compartment with 169 cubic feet of
                storage
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>Inside the Gulfstream IV</h4>
          <div className={styles.text}>
            The interior reveals a world of refined luxury and thoughtful
            design, where every detail caters to the comfort and needs of
            observing travelers. The cabin is a testament to the aircraft&#39;s
            craftsmanship, with interiors that have been meticulously tailored
            by their original owners. While each jet may differ in layout, most
            are configured to seat up to 14 passengers, ensuring a spacious and
            serene in-flight environment.
            <br />
            <br />
            The seating is arranged to foster both relaxation and productivity,
            featuring plush leather chairs that can swivel, recline, and convert
            into lie-flat beds. Common configurations include club-style
            groupings, four-place conference tables, and lounge divans, creating
            versatile zones for dining, meetings, or unwinding mid-flight.
            Functionality is elevated by a fully equipped galley, often
            positioned either at the front or rear of the cabin, depending on
            the specific layout. This space typically includes a microwave,
            refrigerator, dual coffee makers, and ample storage, enabling crew
            to prepare gourmet meals and refreshments throughout the journey.
            <br />
            <br />
            The aircraft also features a private lavatory for passengers located
            at the rear, while many models include a separate crew lavatory at
            the front to preserve privacy and convenience. Storage is another
            strong suit, with an internally accessible baggage compartment
            offering 169 cubic feet of space—more than sufficient for luggage,
            business gear, and personal items.
            <br />
            <br />
            Combined with large oval windows that flood the cabin with natural
            light and advanced soundproofing that minimizes noise, the
            Gulfstream IV&#39;s interior is a sanctuary in the sky—designed to
            make every mile as comfortable as possible.
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>Technological Advancements</h4>
          <div className={styles.text}>
            The Gulfstream IV is renowned for its pioneering technology:
            <br />
            <br />
            <span>Avionics: </span> First business jet to feature an all-glass
            cockpit, equipped with Honeywell SPZ-8000 avionics suite
            <br />
            <span>Engines: </span> Powered by two Rolls-Royce Tay 611-8 turbofan
            engines, offering enhanced fuel efficiency and reduced noise levels
            <br />
            <span>Performance: </span> Capable of reaching altitudes up to
            45,000 feet, ensuring smooth flights above commercial air traffic
            and weather disturbances
            <br />
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>The Gulfstream IV Tech</h4>
          <div className={styles.text}>
            The Gulfstream IV was a trailblazer in business aviation,
            introducing technologies that redefined what a private jet could
            offer. At the heart of its performance are two Rolls-Royce Tay 611-8
            turbofan engines—renowned for their power, efficiency, and
            remarkably quiet operation. These engines not only provide the
            thrust needed for intercontinental flights but also help the
            aircraft achieve exceptional fuel economy and lower emissions for
            its class.
            <br />
            <br />
            What truly set the Gulfstream IV apart during its debut was its
            pioneering flight deck. It was the first business jet to feature an
            all-glass cockpit, replacing conventional analog instruments with
            digital displays that offer pilots superior situational awareness
            and reduced workload. This innovation was complemented by
            Honeywell&#39;s SPZ-8000 avionics suite, which integrates autopilot,
            navigation, communication, and flight management systems into a
            cohesive and intuitive interface.
            <br />
            <br />
            Beyond the cockpit, the aircraft is equipped with satellite
            communications capabilities, enabling global voice and data
            connectivity, an essential feature for business travelers who need
            to stay productive and in touch at 45,000 feet. Advanced flight
            management computers allow for precise route planning and in-flight
            adjustments, enhancing both safety and efficiency.
            <br />
            <br />
            Aerodynamically, the GIV also broke ground by incorporating winglets
            as standard, improving stability and fuel performance. Its light,
            strong wing design contributes to a smoother ride and longer range,
            allowing the aircraft to operate with ease from both major
            international hubs and smaller regional airports.
            <br />
            <br />
            Altogether, the Gulfstream IV represents a seamless integration of
            advanced engineering and pilot-centric design, continuing to deliver
            the technological excellence that made it an industry icon.
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>Historical Significance</h4>
          <div className={styles.text}>
            Since its introduction in 1987, the Gulfstream IV has set the
            standard for business aviation:
            <br />
            <br />
            <span>Legacy: </span> Over 500 units produced, serving corporate
            leaders, government officials, and private individuals worldwide
            <br />
            <span>Evolution:</span> The GIV-SP variant, introduced in 1992,
            offered improved payload and range, later rebranded as the G400
            <br />
            <span>Innovation: </span> Inspired subsequent models like the G350
            and G450, continuing Gulfstream&#39;s tradition of excellence
            <br />
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>
            GIV&#39;s Transformative Upgrade
          </h4>
          <div className={styles.text}>
            The Gulfstream IV holds a distinguished place in aviation history as
            a pivotal aircraft that elevated the standards of private air
            travel. Making its maiden flight in 1985 and entering service two
            years later, the GIV built upon the success of its predecessor, the
            Gulfstream III, while introducing transformative upgrades that
            resonated with both pilots and passengers alike.
            <br />
            <br />
            From the moment it took to the skies, the GIV was praised for its
            enhanced range, modern avionics, and expanded cabin space, elements
            that would influence Gulfstream&#39;s design philosophy for decades.
            The aircraft quickly gained traction among corporate executives,
            heads of state, and elite travelers seeking a reliable, long-range
            jet with uncompromising luxury.
            <br />
            <br />
            The success of the GIV inspired the design of several future models,
            most notably the G350 and G450. These jets carried forward the
            GIV&#39;s legacy, incorporating its foundational engineering while
            adding next-generation advancements. In parallel, the GIV platform
            also proved highly adaptable for military and governmental use.
            Variants such as the C-20F, C-20G, C-20H, and C-20J were
            commissioned for operations by the U.S. military and other global
            defense agencies, further underscoring the aircraft&#39;s
            versatility and durability.
            <br />
            <br />
            Even decades after its debut, the Gulfstream IV remains a respected
            and frequently chartered aircraft—an enduring symbol of innovation
            and excellence in private aviation.
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>
            Why Choose Hera Flight&#39;s Gulfstream IV?
          </h4>
          <div className={styles.text}>
            At Hera Flight, we prioritize your comfort and convenience: Embark
            on your next journey with Hera Flight&#39;s Gulfstream IV and
            experience the pinnacle of private aviation.
            <br />
            <br />
            <span>Personalized Service: </span> Our dedicated team ensures a
            seamless travel experience, tailored to your preferences
            <br />
            <span>Safety and Maintenance: </span> Rigorous maintenance protocols
            and experienced crew members guarantee peace of mind
            <br />
            <span>Global Reach:</span> Whether you&#39;re heading to a business
            meeting across the country or a vacation overseas, The Gulfstream IV
            gets you there efficiently and luxuriously
            <br />
          </div>
        </div>

        <div className={styles.gulfstreamComponentBlock}>
          <h4 className={styles.blockTitle}>Book The Gulfstream IV with Us!</h4>
          <div className={styles.text}>
            Choosing Hera Flight&#39;s Gulfstream IV means selecting more than
            just a mode of transport, you&#39;re embracing a seamless fusion of
            sophistication, performance, and personalized service that
            transforms every journey into an exceptional experience. This
            aircraft is not simply a way to reach your destination; it&#39;s a
            statement of how you choose to travel.
            <br />
            <br />
            From the moment you step aboard, the difference is profound. Our
            Gulfstream IV is meticulously maintained to the highest standards,
            ensuring not only safety and reliability but also an atmosphere of
            pristine comfort. Each flight is tailored to your needs, whether
            you&#39;re flying for business or pleasure, with a crew trained to
            deliver intuitive, discreet service throughout your journey.
            <br />
            <br />
            The GIV&#39;s spacious, custom-crafted interior is perfect for those
            who value privacy, productivity, and indulgence at altitude. Whether
            you&#39;re hosting an in-air meeting, enjoying fine dining above the
            clouds, or simply reclining in a lie-flat seat to relax between
            global cities, Hera Flight ensures every moment in the sky is as
            rewarding as the destination itself.
            <br />
            <br />
            Beyond the cabin, the Gulfstream IV&#39;s long-range capability and
            access to smaller airports grant you the flexibility to fly on your
            terms. Say goodbye to the limitations of commercial travel and hello
            to efficient, direct routes that work with your schedule, not
            against it.
            <br />
            <br />
            With Hera Flight, flying the Gulfstream IV isn’t just a decision of
            convenience—it’s a choice to elevate your entire travel experience.
            Because when every detail matters, nothing less than extraordinary
            will do.
          </div>
        </div>

        <div className={styles.text}>
          <span>
            Note: For the most accurate and up-to-date information on specific
            jet availability and scheduling , please reach out with a call or
            contact form to connect with our customer service team.
          </span>
        </div>
      </div>
    </section>
  );
};

export default GulfstreamComponent;
